import { lang } from "../data/lang";
import { emptys } from "../data/main";

export const strLang = (field, type = false, params) => {
  try {
    let tempLang = !emptys.includes(localStorage.getItem("lang"))
      ? localStorage.getItem("lang")
      : "ing";

    if (!lang[tempLang]) {
      tempLang = "ing";
    }
    if (
      lang[tempLang][field] !== "" ||
      Array.isArray([lang[tempLang][field]])
    ) {
      let tempField = type
        ? lang[tempLang][type][field]
        : lang[tempLang][field];
      field = tempField ?? field;
    }
  } catch (error) {
    console.log("strLang error: ", error);
  }
  if (params) {
    Object.keys(params).map(
      (e) => (field = field.replace(`{${e}}`, params[e]))
    );
  }
  return field;
};
